import React, {
  Fragment,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DatePicker from "react-datepicker";
import { createReactEditorJS } from "react-editor-js";
import { EDITOR_JS_TOOLS } from "../EditorTools/Tools";

import "react-datepicker/dist/react-datepicker.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import Moment from "react-moment";

import { getProfileById, updateProfile } from "../../actions/profile";
import { getActiveUsers, logout } from "../../actions/auth";

import LoggedInNav from "../layout/IME/LoggedInNav";
import GreenSpinner from "../../img/Green_Spinner.gif";
import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import MinimumNav from "../layout/IME/MinimumNav";
import ProfileBackgroundPicsEdit from "../layout/IME/ProfileBackgroundPicsEdit";
import MessageModal from "../layout/IME/MessageModal";

const getCurrentDate = (date) => {
  return (
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "/" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    "/" +
    date.getFullYear()
  );
};

const EditProfile = ({
  match,
  auth: { user },
  profile: { profile, profileloading },
  message: { users },
  isAuthenticated,
  getProfileById,
  getActiveUsers,
  updateProfile,
  logout,
}) => {
  const ReactEditorJS = createReactEditorJS();

  const [imageFile, setFile] = useState({ one: "", two: "" });
  const [imageDataFile, setDataFile] = useState({
    one: "",
    two: "",
  });
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [educationStartDate, setEducationStartDate] = useState(new Date());
  const [educationEndDate, setEducationEndDate] = useState(new Date());
  const [skillStartDate, setSkillStartDate] = useState(new Date());
  const [skillEndDate, setSkillEndDate] = useState(new Date());
  const [User, setUser] = useState({
    username: "",
    employername: "",
    firstname: "",
    lastname: "",
    jobtitle: "",
    location: {
      city: "",
      state: "",
      non_us_state: "",
      country: "US",
    },
  });
  const [socialLinks, setSocialLinks] = useState({
    instagram: "",
    tiktok: "",
    discord: "",
    twitter: "",
    youtube: "",
    facebook: "",
    snapchat: "",
  });
  const [summary, setSummary] = useState("");
  const [employerName, setEmployerName] = useState("");
  const [institutionName, setInstitutionName] = useState("");
  const [skillName, setSkillName] = useState("");
  const [positionItems, setPositionItems] = useState([]);
  const [educationItems, setEducationItems] = useState([]);
  const [skillItems, setSkillItems] = useState([]);
  const [positionItem, setPositionItem] = useState({
    index: null,
    text: "",
  });
  const [skillItem, setSkillItem] = useState({
    index: null,
    text: "",
  });
  const [educationItem, setEducationItem] = useState({
    index: null,
    text: "",
  });
  const [isCurrent, setCurrent] = useState(false);
  const [isCurrentInstitution, setCurrentInstitution] = useState(false);
  const [isCurrentSkill, setCurrentSkill] = useState(false);
  const [experienceObject, setExperienceObject] = useState({
    start: new Date(),
    end: new Date(),
    currentPosition: isCurrent,
    employername: employerName,
    positionDetailItems: positionItems,
  });
  const [educationObject, setEducationObject] = useState({
    start: new Date(),
    end: new Date(),
    currentInstitution: isCurrentInstitution,
    institutionname: institutionName,
    educationDetailItems: educationItems,
  });
  const [skillObject, setSkillObject] = useState({
    start: new Date(),
    end: new Date(),
    currentSkill: isCurrentSkill,
    skillname: skillName,
    skillDetailItems: skillItems,
  });
  const [experienceArray, setExperienceArray] = useState([]);
  const [educationArray, setEducationArray] = useState([]);
  const [skillsArray, setSkillsArray] = useState([]);
  const [newBlocks, setNewBlocks] = useState(false);

  useEffect(() => {
    getProfileById(match.params.channelid);
  }, [match.params.channelid]);

  useEffect(() => {
    getProfileById(match.params.channelid);
  }, [match.params.channelid]);

  useEffect(() => {
    getActiveUsers(User.username);
  }, [User.username]);

  const editorJS = useRef({});

  const handleInitialize = useCallback((instance) => {
    editorJS.current = instance;
  }, []);

  const handleSave = useCallback(async () => {
    const savedData = await editorJS.current.save();

    await updateProfile(
      User,
      savedData,
      summary,
      experienceArray,
      educationArray,
      skillsArray,
      socialLinks,
      imageDataFile
    );
  }, [
    User,
    summary,
    experienceArray,
    educationArray,
    skillsArray,
    socialLinks,
    imageDataFile,
  ]);

  let userNameLimit = User.username.split("").length;

  let firstNameLimit = User.firstname.split("").length;

  let lastNameLimit = User.lastname.split("").length;

  let jobTitleLimit = User.jobtitle.split("").length;

  let companyTitleLimit = User.employername.split("").length;

  // let stateLimit = User.location.non_us_state.split("").length;

  let cityLimit = User.location.city.split("").length;

  const maxLengthUserName = 15;
  const maxLengthFirstName = 30;
  const maxLengthLastName = 30;
  const maxLengthJobTitle = 50;
  const maxLengthState = 50;
  const maxLengthCity = 50;
  const maxLengthSummary = 150;
  const maxLengthEmployerName = 50;
  const maxLengthEmployerDetail = 100;
  const maxLengthInstitution = 50;
  const maxLengthInstitutionDetail = 100;
  const maxLengthSkill = 50;
  const maxLengthSkillDetail = 100;
  const maxLengthInstagram = 50;
  const maxLengthTikTok = 50;
  const maxLengthDiscord = 50;
  const maxLengthTwitter = 50;
  const maxLengthYouTube = 50;
  const maxLengthFaceBook = 50;
  const maxLengthSnapchat = 50;

  // if (profile && profile.data === "Updates Successful") {
  //   return <Redirect to={`/${user && user.channelid}`} />;
  // }

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user.channelid !== match.params.channelid) {
    return <Redirect to="/" />;
  } else if (user.channelid !== profile.channelid) {
    <Redirect to="/" />;
  }

  return (
    <Fragment>
      {profileloading && (
        <div className="profile-picture-overlay">
          <img src={GreenSpinner} />
        </div>
      )}
      {/* <LoggedInNav /> */}
      <MinimumNav user={user} />
      <form
        method="POST"
        className="flex-all-content-fixed-edit-profile"
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
          setFile({ one: "", two: "" });
          setDataFile({ one: "", two: "" });
          setUser({
            username: "",
            employername: "",
            firstname: "",
            lastname: "",
            jobtitle: "",
            location: {
              city: "",
              state: "",
              country: "US",
            },
          });
          setSocialLinks({
            instagram: "",
            tiktok: "",
            discord: "",
            twitter: "",
            youtube: "",
            facebook: "",
            snapchat: "",
          });
          setSummary("");
          setEmployerName("");
          setInstitutionName("");
          setSkillName("");
          setPositionItems([]);
          setEducationItems([]);
          setSkillItems([]);
          setPositionItem({ index: null, text: "" });
          setSkillItem({ index: null, text: "" });
          setEducationItem({ index: null, text: "" });
          setCurrent(false);
          setCurrentInstitution(false);
          setCurrentSkill(false);
          setExperienceArray([]);
          setEducationArray([]);
          setSkillsArray([]);
          setNewBlocks(false);
          logout();
        }}
      >
        <div className="profile-background-pics border-bottom grey">
          <ProfileBackgroundPicsEdit
            user={user}
            profile={profile}
            setFile={setFile}
            setDataFile={setDataFile}
            imageFile={imageFile}
            imageDataFile={imageDataFile}
          />
        </div>
        <div className="items-container">
          <div className="sub-section-container-alt">
            <div className="flex-only">
              <p
                className={`sub-section ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Profile User Info:
              </p>
            </div>
            {user && user.role === "employer" && (
              <div className="input-label-container">
                <label
                  htmlFor="company"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  *Company:
                </label>
                {companyTitleLimit > 50 && (
                  <p className="red bold mb-10">
                    *Company name length too long
                  </p>
                )}
                <input
                  type="text"
                  name="company"
                  max={50}
                  defaultValue={profile.companyname}
                  value={User.employername}
                  className="input-item"
                  placeholder={profile.companyname}
                  onChange={(e) =>
                    setUser({ ...User, employername: e.target.value })
                  }
                />
              </div>
            )}
            <div className="input-label-container">
              <label
                htmlFor="username"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                *Username: (min: 3 max: 15)
              </label>
              {users.length > 0 && (
                <p className="red bold mb-10">*Username already exists</p>
              )}
              {userNameLimit > 15 && (
                <p className="red bold mb-10">*Username length too long</p>
              )}
              {userNameLimit < 3 && User.username !== "" && (
                <p className="red bold mb-10">*Username length too short</p>
              )}
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="username"
                  minLength={3}
                  maxLength={maxLengthUserName}
                  defaultValue={profile.channelid}
                  value={User.username}
                  className={` ${
                    users && users.length > 0
                      ? "input-item-error red"
                      : "input-item"
                  }`}
                  placeholder={profile.channelid}
                  onChange={(e) => {
                    setUser({ ...User, username: e.target.value });
                  }}
                />
                {/* <p className="white character-counter-comment">
                  {User.username.split("").length}/{maxLengthUserName}{" "}
                  characters
                </p> */}
              </div>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="firstname"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                *First Name: (max: 30)
              </label>
              {firstNameLimit > 30 && (
                <p className="red bold mb-10">*First Name length too long</p>
              )}
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="firstname"
                  maxLength={maxLengthFirstName}
                  defaultValue={profile.firstname}
                  value={User.firstname}
                  className="input-item"
                  placeholder={profile.firstname}
                  onChange={(e) =>
                    setUser({ ...User, firstname: e.target.value })
                  }
                />
                {/* <p className="white character-counter-comment">
                  {User.firstname.split("").length}/{maxLengthFirstName}{" "}
                  characters
                </p> */}
              </div>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="lastname"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                *Last Name: (max: 30)
              </label>
              {lastNameLimit > 30 && (
                <p className="red bold mb-10">*Last Name length too long</p>
              )}
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="lastname"
                  maxLength={maxLengthLastName}
                  defaultValue={profile.lastname}
                  value={User.lastname}
                  className="input-item"
                  placeholder={profile.lastname}
                  onChange={(e) =>
                    setUser({ ...User, lastname: e.target.value })
                  }
                />
                {/* <p className="white character-counter-comment">
                  {User.lastname.split("").length}/{maxLengthLastName}{" "}
                  characters
                </p> */}
              </div>
            </div>
            {user && user.role !== "employer" && (
              <div className="input-label-container">
                <label
                  htmlFor="jobtitle"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  *Job Title: (max: 50)
                </label>
                {jobTitleLimit > 50 && (
                  <p className="red bold mb-10">*Job title length too long</p>
                )}
                <div className="edit-input-hidden">
                  <input
                    type="text"
                    name="jobtitle"
                    maxLength={maxLengthJobTitle}
                    defaultValue={profile.jobtitle}
                    value={User.jobtitle}
                    className="input-item"
                    placeholder={profile.jobtitle}
                    onChange={(e) =>
                      setUser({ ...User, jobtitle: e.target.value })
                    }
                  />
                  {/* <p className="white character-counter-comment">
                    {User.jobtitle.split("").length}/{maxLengthJobTitle}{" "}
                    characters
                  </p> */}
                </div>
              </div>
            )}
            <div className="sub-grid-three-alt-subscribe">
              <div className="input-grid">
                <label
                  htmlFor="country"
                  className={`${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  } bold block`}
                >
                  *Country:
                </label>
                <select
                  name="country"
                  id="country"
                  type="country"
                  value={User.location.country}
                  onChange={(e) => {
                    const Location = { ...User };
                    Location.location.country = e.target.value;
                    setUser(Location);
                  }}
                >
                  <option value="US">US</option>
                  <option value="AU">AU</option>
                  <option value="AT">AT</option>
                  <option value="BE">BE</option>
                  <option value="BR">BR</option>
                  <option value="BG">BG</option>
                  <option value="CA">CA</option>
                  <option value="CY">CY</option>
                  <option value="CZ">CZ</option>
                  <option value="DK">DK</option>
                  <option value="EE">EE</option>
                  <option value="FI">FI</option>
                  <option value="FR">FR</option>
                  <option value="DE">DE</option>
                  <option value="GR">GR</option>
                  <option value="HK">HK</option>
                  <option value="HU">HU</option>
                  <option value="IN">IN</option>
                  <option value="IE">IE</option>
                  <option value="IT">IT</option>
                  <option value="JP">JP</option>
                  <option value="LV">LV</option>
                  <option value="LT">LT</option>
                  <option value="LU">LU</option>
                  <option value="MY">MY</option>
                  <option value="MT">MT</option>
                  <option value="MX">MX</option>
                  <option value="NL">NL</option>
                  <option value="NZ">NZ</option>
                  <option value="NO">NO</option>
                  <option value="PL">PL</option>
                  <option value="PT">PT</option>
                  <option value="RO">RO</option>
                  <option value="SG">SG</option>
                  <option value="SK">SK</option>
                  <option value="SI">SI</option>
                  <option value="ES">ES</option>
                  <option value="SE">SE</option>
                  <option value="CH">CH</option>
                  <option value="AE">AE</option>
                  <option value="GB">GB</option>
                </select>
              </div>
              {User.location.country === "US" && (
                <div className="input-grid">
                  <label
                    htmlFor="state"
                    className={`${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    } bold block`}
                  >
                    *State:
                  </label>
                  <select
                    name="state"
                    id="state"
                    type="state"
                    value={User.location.state}
                    onChange={(e) => {
                      const Location = { ...User };
                      Location.location.state = e.target.value;
                      setUser(Location);
                    }}
                  >
                    <option value="Alabama">Alabama</option>
                    <option value="Alaska">Alaska</option>
                    <option value="Arizona">Arizona</option>
                    <option value="Arkansas">Arkansas</option>
                    <option value="California">California</option>
                    <option value="Colorado">Colorado</option>
                    <option value="Connecticut">Connecticut</option>
                    <option value="Delaware">Delaware</option>
                    <option value="Florida">Florida</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Hawaii">Hawaii</option>
                    <option value="Idaho">Idaho</option>
                    <option value="Illinois">Illinois</option>
                    <option value="Indiana">Indiana</option>
                    <option value="Iowa">Iowa</option>
                    <option value="Kansas">Kansas</option>
                    <option value="Kentucky">Kentucky</option>
                    <option value="Louisiana">Louisiana</option>
                    <option value="Maine">Maine</option>
                    <option value="Maryland">Maryland</option>
                    <option value="Massachusetts">Massachusetts</option>
                    <option value="Michigan">Michigan</option>
                    <option value="Minnesota">Minnesota</option>
                    <option value="Mississippi">Mississippi</option>
                    <option value="Missouri">Missouri</option>
                    <option value="Montana">Montana</option>
                    <option value="Nebraska">Nebraska</option>
                    <option value="Nevada">Nevada</option>
                    <option value="New Hampshire">New Hampshire</option>
                    <option value="New Jersey">New Jersey</option>
                    <option value="New Mexico">New Mexico</option>
                    <option value="New York">New York</option>
                    <option value="North Carolina">North Carolina</option>
                    <option value="North Dakota">North Dakota</option>
                    <option value="Ohio">Ohio</option>
                    <option value="Oklahoma">Oklahoma</option>
                    <option value="Oregon">Oregon</option>
                    <option value="Pennsylvania">Pennsylvania</option>
                    <option value="Rhode Island">Rhode Island</option>
                    <option value="South Carolina">South Carolina</option>
                    <option value="South Dakota">South Dakota</option>
                    <option value="Tennessee">Tennessee</option>
                    <option value="Texas">Texas</option>
                    <option value="Utah">Utah</option>
                    <option value="Vermont">Vermont</option>
                    <option value="Virginia">Virginia</option>
                    <option value="Washington">Washington</option>
                    <option value="West Virginia">West Virginia</option>
                    <option value="Wisconsin">Wisconsin</option>
                    <option value="Wyoming">Wyoming</option>
                  </select>
                </div>
              )}
              {User.location.country !== "US" && (
                <div className="input-grid">
                  <label
                    htmlFor="state"
                    className={`${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    } bold block`}
                  >
                    *State:
                  </label>
                  {/* {stateLimit > 50 && (
                    <p className="red bold mb-10">*State name too long</p>
                  )} */}
                  <div className="edit-input-hidden">
                    <input
                      className="input-item"
                      name="state"
                      id="state"
                      type="state"
                      maxLength={maxLengthState}
                      placeholder="Enter State"
                      autoComplete="state"
                      value={User.location.state}
                      onChange={(e) => {
                        const Location = { ...User };
                        Location.location.state = e.target.value;
                        setUser(Location);
                      }}
                    />
                    <p className="white character-counter-comment">
                      {User.location.state.split("").length}/{maxLengthState}{" "}
                      characters
                    </p>
                  </div>
                </div>
              )}
              <div className="input-grid">
                <label
                  htmlFor="city"
                  className={`${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  } bold block`}
                >
                  *City: (max: 50)
                </label>
                {cityLimit > 50 && (
                  <p className="red bold mb-10">*City name too long</p>
                )}
                <div className="edit-input-hidden">
                  <input
                    className="input-item"
                    name="city"
                    id="city"
                    type="text"
                    maxLength={maxLengthCity}
                    placeholder="Enter City"
                    autoComplete="city"
                    value={User.location.city}
                    onChange={(e) => {
                      const Location = { ...User };
                      Location.location.city = e.target.value;
                      setUser(Location);
                    }}
                  />
                  <p className="white character-counter-comment">
                    {User.location.city.split("").length}/{maxLengthCity}{" "}
                    characters
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="items-container">
          <div className="sub-section-container-alt">
            <div className="flex-only">
              <p
                className={`sub-section ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Profile Biography:
              </p>
            </div>
            <ReactEditorJS
              holder="custom"
              onInitialize={handleInitialize}
              tools={EDITOR_JS_TOOLS}
              onChange={() => {
                if (
                  editorJS.current._editorJS.configuration.data.blocks.length >
                  0
                ) {
                  setNewBlocks(true);
                } else {
                  setNewBlocks(false);
                }
              }}
            >
              {" "}
              <div id="custom" className="edit-bio white" />
            </ReactEditorJS>
          </div>
        </div>
        <div className="items-container">
          <div className="sub-section-container-alt">
            <div className="flex-only">
              <p
                className={`sub-section ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Professional Summary:
              </p>
            </div>
            <textarea
              value={summary}
              maxLength={maxLengthSummary}
              placeholder={
                profile.resume
                  ? profile.resume.professionalsummary
                  : "Enter Professional Summary"
              }
              onChange={(e) => setSummary(e.target.value)}
              className="edit-summary"
            ></textarea>
            <p className="white character-counter-comment">
              {summary.split("").length}/{maxLengthSummary} characters
            </p>
          </div>
        </div>
        <div className="items-container">
          <div className="sub-section-container-alt">
            <div className="flex-only">
              <p
                className={`sub-section ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Add New Experience:
              </p>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="startdate"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Start Date:
              </label>
              <DatePicker
                className="input-item white"
                selected={startDate}
                maxDate={endDate}
                onChange={(date) => {
                  setStartDate(date);
                  setExperienceObject({ ...experienceObject, start: date });
                }}
              />
            </div>
            {!isCurrent && (
              <div>
                <label
                  htmlFor="enddate"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  End Date:
                </label>
                <DatePicker
                  className="input-item white"
                  selected={endDate}
                  minDate={startDate}
                  onChange={(date) => {
                    setEndDate(date);
                    setExperienceObject({ ...experienceObject, end: date });
                  }}
                />
              </div>
            )}
            {isCurrent && (
              <div>
                <label
                  htmlFor="enddate"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  End Date:
                </label>
                <input
                  type="text"
                  name="experiencename"
                  value="Current"
                  className="input-item"
                  placeholder="Enter Detail of Position"
                />
              </div>
            )}
            <div className="checkboxes-alt">
              <input
                className="mx-5 checkbox"
                type="checkbox"
                checked={isCurrent}
                onChange={(e) => {
                  setCurrent(e.target.checked);
                  setExperienceObject({
                    ...experienceObject,
                    currentPosition: e.target.checked,
                  });
                }}
              ></input>
              <span
                className={`${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Current Position
              </span>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="startdate"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Employer Name:
              </label>
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="experiencename"
                  value={employerName}
                  maxLength={maxLengthEmployerName}
                  className="input-item"
                  placeholder="Enter Employer Name"
                  onChange={(e) => {
                    setEmployerName(e.target.value);
                    setExperienceObject({
                      ...experienceObject,
                      employername: e.target.value,
                    });
                  }}
                />
                <p className="white character-counter-comment">
                  {employerName.split("").length}/{maxLengthEmployerName}{" "}
                  characters
                </p>
              </div>
            </div>
            {positionItems.length < 5 && (
              <div className="input-label-container">
                <label
                  htmlFor="startdate"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  Detail about position:
                </label>
                <div className="edit-input-hidden">
                  <input
                    type="text"
                    name="experiencename"
                    value={positionItem.text}
                    maxLength={maxLengthEmployerDetail}
                    className="input-item"
                    placeholder="Enter Detail of Position"
                    onChange={(e) => {
                      setPositionItem({
                        text: e.target.value,
                        index: 0,
                      });
                    }}
                  />
                  <p className="white character-counter-comment">
                    {positionItem.text.split("").length}/
                    {maxLengthEmployerDetail} characters
                  </p>
                </div>
              </div>
            )}
            {positionItems.length < 5 && positionItem.text !== "" && (
              <div
                className="iterate-item"
                onClick={() => {
                  setPositionItems([...positionItems, positionItem.text]);
                  setExperienceObject({
                    ...experienceObject,
                    positionDetailItems: [
                      ...experienceObject.positionDetailItems,
                      positionItem,
                    ],
                  });
                  setPositionItem({ text: "" });
                }}
              >
                <p className="new-item">
                  <i
                    className={`fas fa-plus mr-5 ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>{" "}
                  Add new position detail
                </p>
              </div>
            )}
            {positionItems.map((item, index) => {
              return (
                <div className="input-label-container" key={index}>
                  <label
                    htmlFor="startdate"
                    className={`labels-input ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  >
                    Detail about position:
                  </label>
                  <input
                    type="text"
                    name="experiencename"
                    value={item}
                    className="input-item"
                    placeholder="Enter Detail of Position"
                  />
                  <div
                    className="iterate-item"
                    index={index}
                    onClick={(e) => {
                      positionItems.splice(
                        e.currentTarget.attributes.index.value,
                        1
                      );
                      setPositionItems([...positionItems]);
                      experienceObject.positionDetailItems.splice(
                        e.currentTarget.attributes.index.value,
                        1
                      );
                      setExperienceObject({
                        ...experienceObject,
                        positionDetailItems: [
                          ...experienceObject.positionDetailItems,
                        ],
                      });
                    }}
                  >
                    <p className="new-item">
                      <i
                        className={`fas fa-times mr-5 ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      ></i>{" "}
                      Remove position detail
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          {employerName !== "" && positionItems.length > 0 && (
            <div
              className="iterate-item-alt"
              onClick={() => {
                setExperienceArray([...experienceArray, experienceObject]);
                setStartDate(new Date());
                setEndDate(new Date());
                setEmployerName("");
                setPositionItem({ text: "" });
                setPositionItems([]);
                setCurrent(false);
                setExperienceObject({
                  start: new Date(),
                  end: new Date(),
                  currentPosition: false,
                  employername: "",
                  positionDetailItems: [],
                });
              }}
            >
              <p className="new-item">
                <i
                  className={`fas fa-plus mr-5 ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>{" "}
                Add experience
              </p>
            </div>
          )}
        </div>
        {experienceArray.length > 0 &&
          experienceArray.map((object, index) => {
            return (
              <div className="items-container" key={index} index={index}>
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p
                      className={`sub-section ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      {object.employername}
                    </p>
                  </div>
                  <div className="input-label-container">
                    <label
                      htmlFor="startdate"
                      className={`labels-input ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Start Date:
                    </label>
                    <input
                      className="input-item white"
                      value={getCurrentDate(object.start)}
                    />
                  </div>
                  {!object.currentPosition && (
                    <div>
                      <label
                        htmlFor="enddate"
                        className={`labels-input ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        End Date:
                      </label>
                      <input
                        className="input-item white"
                        value={getCurrentDate(object.end)}
                      />
                    </div>
                  )}
                  {object.currentPosition && (
                    <div>
                      <label
                        htmlFor="enddate"
                        className={`labels-input ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        End Date:
                      </label>
                      <input
                        type="text"
                        name="experiencename"
                        value="Current"
                        className="input-item"
                      />
                    </div>
                  )}
                  <div className="checkboxes-alt">
                    <input
                      className="mx-5 checkbox"
                      type="checkbox"
                      checked={object.currentPosition}
                    ></input>
                    <span
                      className={`${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Current Position
                    </span>
                  </div>
                  <div className="input-label-container">
                    <label
                      htmlFor="startdate"
                      className={`labels-input ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Employer Name:
                    </label>
                    <input
                      type="text"
                      name="experiencename"
                      value={object.employername}
                      className="input-item"
                    />
                  </div>
                  {object.positionDetailItems.map((item) => {
                    return (
                      <div className="input-label-container" key={item.index}>
                        <label
                          htmlFor="startdate"
                          className={`labels-input ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        >
                          Detail about position:
                        </label>
                        <input
                          type="text"
                          name="experiencename"
                          value={item.text}
                          className="input-item"
                          placeholder="Enter Detail of Position"
                        />
                        {/* <div
                            className="iterate-item"
                            index={index}
                            onClick={(e) => {
                              positionItems.splice(
                                e.currentTarget.attributes.index.value,
                                1
                              );
                              setPositionItems([...positionItems]);
                            }}
                          >
                            <p className="new-item">
                              <i className={`fas fa-times mr-5 ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}></i> Remove
                              position detail
                            </p>
                          </div> */}
                      </div>
                    );
                  })}
                </div>
                <div
                  className="iterate-item-alt"
                  onClick={() => {
                    experienceArray.splice(index, 1);
                    setExperienceArray([...experienceArray]);
                    setExperienceObject({
                      start: new Date(),
                      end: new Date(),
                      currentPosition: false,
                      employername: "",
                      positionDetailItems: [],
                    });
                  }}
                >
                  <p className="new-item">
                    <i
                      className={`fas fa-times mr-5 ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    ></i>{" "}
                    Remove experience
                  </p>
                </div>
              </div>
            );
          })}
        {profile.resume &&
          profile.resume.experience.length > 0 &&
          profile.resume.experience.map((object, index) => {
            return (
              <div className="items-container" key={index} index={index}>
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p
                      className={`sub-section ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      {object.employer}
                    </p>
                  </div>
                  <div className="input-label-container">
                    <label
                      htmlFor="startdate"
                      className={`labels-input ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Start Date:
                    </label>
                    <li className="resume-item-description white" key={index}>
                      <Moment format="MM/DD/YYYY">{object.from}</Moment>
                    </li>
                  </div>
                  {!object.current && (
                    <div>
                      <label
                        htmlFor="enddate"
                        className={`labels-input ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        End Date:
                      </label>
                      <li className="resume-item-description white" key={index}>
                        <Moment format="MM/DD/YYYY">{object.to}</Moment>
                      </li>
                    </div>
                  )}
                  <div className="checkboxes-alt">
                    <input
                      className="mx-5 checkbox"
                      type="checkbox"
                      checked={object.current}
                    ></input>
                    <span
                      className={`${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Current Position
                    </span>
                  </div>
                  {object.description.map((item) => {
                    return (
                      <div className="input-label-container" key={item.index}>
                        <label
                          htmlFor="startdate"
                          className={`labels-input ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        >
                          Detail about position:
                        </label>
                        <li
                          className="resume-item-description white"
                          key={index}
                        >
                          {item.item}
                          <i
                            className="fas fa-times fa-sm white times-sm mx-10"
                            onClick={() => {}}
                          ></i>
                        </li>
                      </div>
                    );
                  })}
                </div>
                <div
                  className="iterate-item-alt"
                  // onClick={() => {
                  //   experienceArray.splice(index, 1);
                  //   setExperienceArray([...experienceArray]);
                  //   setExperienceObject({
                  //     start: new Date(),
                  //     end: new Date(),
                  //     currentPosition: false,
                  //     employername: "",
                  //     positionDetailItems: [],
                  //   });
                  // }}
                >
                  <p className="new-item">
                    <i className="fas fa-times mr-5 red"></i> Delete experience
                  </p>
                </div>
              </div>
            );
          })}
        <div className="items-container">
          <div className="sub-section-container-alt">
            <div className="flex-only">
              <p
                className={`sub-section ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Add New Education:
              </p>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="startdate"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Start Date:
              </label>
              <DatePicker
                className="input-item white"
                selected={educationStartDate}
                maxDate={educationEndDate}
                onChange={(date) => {
                  setEducationStartDate(date);
                  setEducationObject({ ...educationObject, start: date });
                }}
              />
            </div>
            {!isCurrentInstitution && (
              <div>
                <label
                  htmlFor="enddate"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  End Date:
                </label>
                <DatePicker
                  className="input-item white"
                  selected={educationEndDate}
                  minDate={educationStartDate}
                  onChange={(date) => {
                    setEducationEndDate(date);
                    setEducationObject({ ...educationObject, end: date });
                  }}
                />
              </div>
            )}
            {isCurrentInstitution && (
              <div>
                <label
                  htmlFor="enddate"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  End Date:
                </label>
                <input
                  type="text"
                  name="experiencename"
                  value="Current"
                  className="input-item"
                  placeholder="Enter Detail of Position"
                />
              </div>
            )}
            <div className="checkboxes-alt">
              <input
                className="mx-5 checkbox"
                type="checkbox"
                checked={isCurrentInstitution}
                onChange={(e) => {
                  setCurrentInstitution(e.target.checked);
                  setEducationObject({
                    ...educationObject,
                    currentInstitution: e.target.checked,
                  });
                }}
              ></input>
              <span
                className={`${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Current Institution
              </span>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="institutionname"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Institution Name:
              </label>
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="institutionname"
                  value={institutionName}
                  maxLength={maxLengthInstitution}
                  className="input-item"
                  placeholder="Enter Institution Name"
                  onChange={(e) => {
                    setInstitutionName(e.target.value);
                    setEducationObject({
                      ...educationObject,
                      institutionname: e.target.value,
                    });
                  }}
                />
                <p className="white character-counter-comment">
                  {institutionName.split("").length}/{maxLengthInstitution}{" "}
                  characters
                </p>
              </div>
            </div>
            {educationItems.length < 5 && (
              <div className="input-label-container">
                <label
                  htmlFor="educationname"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  Detail about skill obtained:
                </label>
                <div className="edit-input-hidden">
                  <input
                    type="text"
                    name="educationname"
                    value={educationItem.text}
                    maxLength={maxLengthInstitutionDetail}
                    className="input-item"
                    placeholder="Enter Detail of Skill obtained"
                    onChange={(e) => {
                      setEducationItem({
                        text: e.target.value,
                        index: 0,
                      });
                    }}
                  />
                  <p className="white character-counter-comment">
                    {educationItem.text.split("").length}/
                    {maxLengthInstitutionDetail} characters
                  </p>
                </div>
              </div>
            )}
            {educationItems.length < 5 && educationItem.text !== "" && (
              <div
                className="iterate-item"
                onClick={() => {
                  setEducationItems([...educationItems, educationItem.text]);
                  setEducationObject({
                    ...educationObject,
                    educationDetailItems: [
                      ...educationObject.educationDetailItems,
                      educationItem,
                    ],
                  });
                  setEducationItem({ text: "" });
                }}
              >
                <p className="new-item">
                  <i
                    className={`fas fa-plus mr-5 ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>{" "}
                  Add new education detail
                </p>
              </div>
            )}
            {educationItems.map((item, index) => {
              return (
                <div className="input-label-container" key={index}>
                  <label
                    htmlFor="educationname"
                    className={`labels-input ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  >
                    Detail of skill obtained:
                  </label>
                  <input
                    type="text"
                    name="educationname"
                    value={item}
                    className="input-item"
                    placeholder="Enter Detail of Skill obtained"
                  />
                  <div
                    className="iterate-item"
                    index={index}
                    onClick={(e) => {
                      educationItems.splice(
                        e.currentTarget.attributes.index.value,
                        1
                      );
                      setEducationItems([...educationItems]);
                      educationObject.educationDetailItems.splice(
                        e.currentTarget.attributes.index.value,
                        1
                      );
                      setEducationObject({
                        ...educationObject,
                        educationDetailItems: [
                          ...educationObject.educationDetailItems,
                        ],
                      });
                    }}
                  >
                    <p className="new-item">
                      <i
                        className={`fas fa-times mr-5 ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      ></i>{" "}
                      Remove skill detail
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          {institutionName !== "" && educationItems.length > 0 && (
            <div
              className="iterate-item-alt"
              onClick={() => {
                setEducationArray([...educationArray, educationObject]);
                setEducationStartDate(new Date());
                setEducationEndDate(new Date());
                setInstitutionName("");
                setEducationItem({ text: "" });
                setEducationItems([]);
                setCurrentInstitution(false);
                setEducationObject({
                  start: new Date(),
                  end: new Date(),
                  currentInstitution: false,
                  institutionname: "",
                  educationDetailItems: [],
                });
              }}
            >
              <p className="new-item">
                <i
                  className={`fas fa-plus mr-5 ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>{" "}
                Add education
              </p>
            </div>
          )}
        </div>
        {educationArray.length > 0 &&
          educationArray.map((object, index) => {
            return (
              <div className="items-container" key={index} index={index}>
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p
                      className={`sub-section ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      {object.institutionname}
                    </p>
                  </div>
                  <div className="input-label-container">
                    <label
                      htmlFor="startdate"
                      className={`labels-input ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Start Date:
                    </label>
                    <input
                      className="input-item white"
                      value={getCurrentDate(object.start)}
                    />
                  </div>
                  {!object.currentInstitution && (
                    <div>
                      <label
                        htmlFor="enddate"
                        className={`labels-input ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        End Date:
                      </label>
                      <input
                        className="input-item white"
                        value={getCurrentDate(object.end)}
                      />
                    </div>
                  )}
                  {object.currentInstitution && (
                    <div>
                      <label
                        htmlFor="enddate"
                        className={`labels-input ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        End Date:
                      </label>
                      <input
                        type="text"
                        name="experiencename"
                        value="Current"
                        className="input-item"
                      />
                    </div>
                  )}
                  <div className="checkboxes-alt">
                    <input
                      className="mx-5 checkbox"
                      type="checkbox"
                      checked={object.currentInstitution}
                    ></input>
                    <span
                      className={`${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Current Institution
                    </span>
                  </div>
                  <div className="input-label-container">
                    <label
                      htmlFor="institutionname"
                      className={`labels-input ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Institution Name:
                    </label>
                    <input
                      type="text"
                      name="institutionname"
                      value={object.institutionname}
                      className="input-item"
                    />
                  </div>
                  {object.educationDetailItems.map((item) => {
                    return (
                      <div className="input-label-container" key={item.index}>
                        <label
                          htmlFor="startdate"
                          className={`labels-input ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        >
                          Detail about skill obtained:
                        </label>
                        <input
                          type="text"
                          name="educationname"
                          value={item.text}
                          className="input-item"
                          placeholder="Enter Detail of Skill obtained"
                        />
                        {/* <div
                            className="iterate-item"
                            index={index}
                            onClick={(e) => {
                              positionItems.splice(
                                e.currentTarget.attributes.index.value,
                                1
                              );
                              setPositionItems([...positionItems]);
                            }}
                          >
                            <p className="new-item">
                              <i className={`fas fa-times mr-5 ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}></i> Remove
                              position detail
                            </p>
                          </div> */}
                      </div>
                    );
                  })}
                </div>
                <div
                  className="iterate-item-alt"
                  onClick={() => {
                    educationArray.splice(index, 1);
                    setEducationArray([...educationArray]);
                    setEducationObject({
                      start: new Date(),
                      end: new Date(),
                      currentInstitution: false,
                      institutionname: "",
                      educationDetailItems: [],
                    });
                  }}
                >
                  <p className="new-item">
                    <i
                      className={`fas fa-times mr-5 ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    ></i>{" "}
                    Remove education
                  </p>
                </div>
              </div>
            );
          })}
        {profile.resume &&
          profile.resume.education.length > 0 &&
          profile.resume.education.map((object, index) => {
            return (
              <div className="items-container" key={index} index={index}>
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p
                      className={`sub-section ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      {object.institution}
                    </p>
                  </div>
                  <div className="input-label-container">
                    <label
                      htmlFor="startdate"
                      className={`labels-input ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Start Date:
                    </label>
                    <li className="resume-item-description white" key={index}>
                      <Moment format="MM/DD/YYYY">{object.from}</Moment>
                    </li>
                  </div>
                  {!object.current && (
                    <div>
                      <label
                        htmlFor="enddate"
                        className={`labels-input ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        End Date:
                      </label>
                      <li className="resume-item-description white" key={index}>
                        <Moment format="MM/DD/YYYY">{object.to}</Moment>
                      </li>
                    </div>
                  )}
                  <div className="checkboxes-alt">
                    <input
                      className="mx-5 checkbox"
                      type="checkbox"
                      checked={object.current}
                    ></input>
                    <span
                      className={`${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Current Institution
                    </span>
                  </div>
                  {object.description.map((item) => {
                    return (
                      <div className="input-label-container" key={item.index}>
                        <label
                          htmlFor="startdate"
                          className={`labels-input ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        >
                          Detail about institution:
                        </label>
                        <li
                          className="resume-item-description white"
                          key={index}
                        >
                          {item.item}
                          <i
                            className="fas fa-times fa-sm white times-sm mx-10"
                            onClick={() => {}}
                          ></i>
                        </li>
                      </div>
                    );
                  })}
                </div>
                <div
                  className="iterate-item-alt"
                  // onClick={() => {
                  //   educationArray.splice(index, 1);
                  //   setExperienceArray([...educationArray]);
                  //   setExperienceObject({
                  //     start: new Date(),
                  //     end: new Date(),
                  //     currentPosition: false,
                  //     employername: "",
                  //     positionDetailItems: [],
                  //   });
                  // }}
                >
                  <p className="new-item">
                    <i className="fas fa-times mr-5 red"></i> Delete education
                  </p>
                </div>
              </div>
            );
          })}
        <div className="items-container">
          <div className="sub-section-container-alt">
            <div className="flex-only">
              <p
                className={`sub-section ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Add New Skill:
              </p>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="startdate"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Start Date:
              </label>
              <DatePicker
                className="input-item white"
                selected={skillStartDate}
                maxDate={skillEndDate}
                onChange={(date) => {
                  setSkillStartDate(date);
                  setSkillObject({ ...educationObject, start: date });
                }}
              />
            </div>
            {!isCurrentSkill && (
              <div>
                <label
                  htmlFor="enddate"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  End Date:
                </label>
                <DatePicker
                  className="input-item white"
                  selected={skillEndDate}
                  minDate={skillStartDate}
                  onChange={(date) => {
                    setSkillEndDate(date);
                    setSkillObject({ ...educationObject, end: date });
                  }}
                />
              </div>
            )}
            {isCurrentSkill && (
              <div>
                <label
                  htmlFor="enddate"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  End Date:
                </label>
                <input
                  type="text"
                  name="skillname"
                  value="Current"
                  className="input-item"
                  placeholder="Enter Name of Skill"
                />
              </div>
            )}
            <div className="checkboxes-alt">
              <input
                className="mx-5 checkbox"
                type="checkbox"
                checked={isCurrentSkill}
                onChange={(e) => {
                  setCurrentSkill(e.target.checked);
                  setSkillObject({
                    ...skillObject,
                    currentSkill: e.target.checked,
                  });
                }}
              ></input>
              <span
                className={`${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Current Skill
              </span>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="skillname"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Skill Name:
              </label>
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="skillname"
                  value={skillName}
                  maxLength={maxLengthSkill}
                  className="input-item"
                  placeholder="Enter Skill Name"
                  onChange={(e) => {
                    setSkillName(e.target.value);
                    setSkillObject({
                      ...skillObject,
                      skillname: e.target.value,
                    });
                  }}
                />
                <p className="white character-counter-comment">
                  {skillName.split("").length}/{maxLengthSkill} characters
                </p>
              </div>
            </div>
            {skillItems.length < 5 && (
              <div className="input-label-container">
                <label
                  htmlFor="skillname"
                  className={`labels-input ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  Detail about skill obtained:
                </label>
                <div className="edit-input-hidden">
                  <input
                    type="text"
                    name="skillname"
                    value={skillItem.text}
                    maxLength={maxLengthSkillDetail}
                    className="input-item"
                    placeholder="Enter Detail of Skill obtained"
                    onChange={(e) => {
                      setSkillItem({
                        text: e.target.value,
                        index: 0,
                      });
                    }}
                  />
                  <p className="white character-counter-comment">
                    {skillItem.text.split("").length}/{maxLengthSkillDetail}{" "}
                    characters
                  </p>
                </div>
              </div>
            )}
            {skillItems.length < 5 && skillItem.text !== "" && (
              <div
                className="iterate-item"
                onClick={() => {
                  setSkillItems([...skillItems, skillItem.text]);
                  setSkillObject({
                    ...skillObject,
                    skillDetailItems: [
                      ...skillObject.skillDetailItems,
                      skillItem,
                    ],
                  });
                  setSkillItem({ text: "" });
                }}
              >
                <p className="new-item">
                  <i
                    className={`fas fa-plus mr-5 ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>{" "}
                  Add new education detail
                </p>
              </div>
            )}
            {skillItems.map((item, index) => {
              return (
                <div className="input-label-container" key={index}>
                  <label
                    htmlFor="skillname"
                    className={`labels-input ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  >
                    Detail of skill obtained:
                  </label>
                  <input
                    type="text"
                    name="skillname"
                    value={item}
                    className="input-item"
                    placeholder="Enter Detail of Skill obtained"
                  />
                  <div
                    className="iterate-item"
                    index={index}
                    onClick={(e) => {
                      skillItems.splice(
                        e.currentTarget.attributes.index.value,
                        1
                      );
                      setSkillItems([...skillItems]);
                      skillObject.skillDetailItems.splice(
                        e.currentTarget.attributes.index.value,
                        1
                      );
                      setSkillObject({
                        ...skillObject,
                        skillDetailItems: [...skillObject.skillDetailItems],
                      });
                    }}
                  >
                    <p className="new-item">
                      <i
                        className={`fas fa-times mr-5 ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      ></i>{" "}
                      Remove skill detail
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          {skillName !== "" && skillItems.length > 0 && (
            <div
              className="iterate-item-alt"
              onClick={() => {
                setSkillsArray([...skillsArray, skillObject]);
                setSkillStartDate(new Date());
                setSkillEndDate(new Date());
                setSkillName("");
                setSkillItem({ text: "" });
                setSkillItems([]);
                setCurrentSkill(false);
                setSkillObject({
                  start: new Date(),
                  end: new Date(),
                  currentSkill: false,
                  skillname: "",
                  skillDetailItems: [],
                });
              }}
            >
              <p className="new-item">
                <i
                  className={`fas fa-plus mr-5 ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>{" "}
                Add skill
              </p>
            </div>
          )}
        </div>
        {skillsArray.length > 0 &&
          skillsArray.map((object, index) => {
            return (
              <div className="items-container" key={index} index={index}>
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p
                      className={`sub-section ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      {object.skillname}
                    </p>
                  </div>
                  <div className="input-label-container">
                    <label
                      htmlFor="startdate"
                      className={`labels-input ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Start Date:
                    </label>
                    <input
                      className="input-item white"
                      value={getCurrentDate(object.start)}
                    />
                  </div>
                  {!object.currentSkill && (
                    <div>
                      <label
                        htmlFor="enddate"
                        className={`labels-input ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        End Date:
                      </label>
                      <input
                        className="input-item white"
                        value={getCurrentDate(object.end)}
                      />
                    </div>
                  )}
                  {object.currentSkill && (
                    <div>
                      <label
                        htmlFor="enddate"
                        className={`labels-input ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        End Date:
                      </label>
                      <input
                        type="text"
                        name="experiencename"
                        value="Current"
                        className="input-item"
                      />
                    </div>
                  )}
                  <div className="checkboxes-alt">
                    <input
                      className="mx-5 checkbox"
                      type="checkbox"
                      checked={object.currentSkill}
                    ></input>
                    <span
                      className={`${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Current Skill
                    </span>
                  </div>
                  <div className="input-label-container">
                    <label
                      htmlFor="skillname"
                      className={`labels-input ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      Skill Name:
                    </label>
                    <input
                      type="text"
                      name="skillname"
                      value={object.skillname}
                      className="input-item"
                    />
                  </div>
                  {object.skillDetailItems.map((item) => {
                    return (
                      <div className="input-label-container" key={item.index}>
                        <label
                          htmlFor="startdate"
                          className={`labels-input ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        >
                          Detail about skill obtained:
                        </label>
                        <input
                          type="text"
                          name="skillname"
                          value={item.text}
                          className="input-item"
                          placeholder="Enter Detail of Skill obtained"
                        />
                        {/* <div
                            className="iterate-item"
                            index={index}
                            onClick={(e) => {
                              positionItems.splice(
                                e.currentTarget.attributes.index.value,
                                1
                              );
                              setPositionItems([...positionItems]);
                            }}
                          >
                            <p className="new-item">
                              <i className={`fas fa-times mr-5 ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}></i> Remove
                              position detail
                            </p>
                          </div> */}
                      </div>
                    );
                  })}
                </div>
                <div
                  className="iterate-item-alt"
                  onClick={() => {
                    skillsArray.splice(index, 1);
                    setSkillsArray([...skillsArray]);
                    setSkillObject({
                      start: new Date(),
                      end: new Date(),
                      currentSkill: false,
                      skillname: "",
                      skillDetailItems: [],
                    });
                  }}
                >
                  <p className="new-item">
                    <i
                      className={`fas fa-times mr-5 ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    ></i>{" "}
                    Remove skill
                  </p>
                </div>
              </div>
            );
          })}
        <div className="items-container mb-20">
          <div className="sub-section-container-alt">
            <div className="flex-only">
              <p
                className={`sub-section ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                User Social Links:
              </p>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="instagram"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i
                  className={`fab fa-instagram ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  } mr-5`}
                ></i>
                Instagram:
              </label>
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="instagram"
                  value={socialLinks.instagram}
                  maxLength={maxLengthInstagram}
                  className="input-item"
                  placeholder={
                    profile.sociallinks && profile.sociallinks.instagram !== ""
                      ? profile.sociallinks.instagram
                      : "Enter Link to Instagram Profile"
                  }
                  onChange={(e) =>
                    setSocialLinks({
                      ...socialLinks,
                      instagram: e.target.value,
                    })
                  }
                />
                <p className="white character-counter-comment">
                  {socialLinks.instagram.split("").length}/{maxLengthInstagram}{" "}
                  characters
                </p>
              </div>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="tiktok"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i
                  className={`fab fa-tiktok ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  } mr-5`}
                ></i>
                TikTok:
              </label>
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="tiktok"
                  value={socialLinks.tiktok}
                  maxLength={maxLengthTikTok}
                  className="input-item"
                  placeholder={
                    profile.sociallinks && profile.sociallinks.tiktok !== ""
                      ? profile.sociallinks.tiktok
                      : "Enter Link to TikTok Profile"
                  }
                  onChange={(e) =>
                    setSocialLinks({ ...socialLinks, tiktok: e.target.value })
                  }
                />
                <p className="white character-counter-comment">
                  {socialLinks.tiktok.split("").length}/{maxLengthTikTok}{" "}
                  characters
                </p>
              </div>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="discord"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i
                  className={`fab fa-discord ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  } mr-5`}
                ></i>
                Discord:
              </label>
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="discord"
                  value={socialLinks.discord}
                  maxLength={maxLengthDiscord}
                  className="input-item"
                  placeholder={
                    profile.sociallinks && profile.sociallinks.discord !== ""
                      ? profile.sociallinks.discord
                      : "Enter Link to Discord Profile"
                  }
                  onChange={(e) =>
                    setSocialLinks({
                      ...socialLinks,
                      discord: e.target.value,
                    })
                  }
                />
                <p className="white character-counter-comment">
                  {socialLinks.discord.split("").length}/{maxLengthDiscord}{" "}
                  characters
                </p>
              </div>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="twitter"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i
                  className={`fab fa-twitter ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  } mr-5`}
                ></i>
                Twitter:
              </label>
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="twitter"
                  value={socialLinks.twitter}
                  maxLength={maxLengthTwitter}
                  className="input-item"
                  placeholder={
                    profile.sociallinks && profile.sociallinks.twitter !== ""
                      ? profile.sociallinks.twitter
                      : "Enter Link to Twitter Profile"
                  }
                  onChange={(e) =>
                    setSocialLinks({
                      ...socialLinks,
                      twitter: e.target.value,
                    })
                  }
                />
                <p className="white character-counter-comment">
                  {socialLinks.twitter.split("").length}/{maxLengthTwitter}{" "}
                  characters
                </p>
              </div>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="youtube"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i
                  className={`fab fa-youtube ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  } mr-5`}
                ></i>
                YouTube:
              </label>
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="youtube"
                  value={socialLinks.youtube}
                  maxLength={maxLengthYouTube}
                  className="input-item"
                  placeholder={
                    profile.sociallinks && profile.sociallinks.youtube !== ""
                      ? profile.sociallinks.youtube
                      : "Enter Link to YouTube Profile"
                  }
                  onChange={(e) =>
                    setSocialLinks({
                      ...socialLinks,
                      youtube: e.target.value,
                    })
                  }
                />
                <p className="white character-counter-comment">
                  {socialLinks.youtube.split("").length}/{maxLengthYouTube}{" "}
                  characters
                </p>
              </div>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="facebook"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i
                  className={`fab fa-facebook ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  } mr-5`}
                ></i>
                FaceBook:
              </label>
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="facebook"
                  value={socialLinks.facebook}
                  maxLength={maxLengthFaceBook}
                  className="input-item"
                  placeholder={
                    profile.sociallinks && profile.sociallinks.facebook !== ""
                      ? profile.sociallinks.facebook
                      : "Enter Link to FaceBook Profile"
                  }
                  onChange={(e) =>
                    setSocialLinks({
                      ...socialLinks,
                      facebook: e.target.value,
                    })
                  }
                />
                <p className="white character-counter-comment">
                  {socialLinks.facebook.split("").length}/{maxLengthFaceBook}{" "}
                  characters
                </p>
              </div>
            </div>
            <div className="input-label-container">
              <label
                htmlFor="snapchat"
                className={`labels-input ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i
                  className={`fab fa-snapchat ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  } mr-5`}
                ></i>
                Snapchat:
              </label>
              <div className="edit-input-hidden">
                <input
                  type="text"
                  name="snapchat"
                  value={socialLinks.snapchat}
                  maxLength={maxLengthSnapchat}
                  className="input-item"
                  placeholder={
                    profile.sociallinks && profile.sociallinks.snapchat !== ""
                      ? profile.sociallinks.snapchat
                      : "Enter SnapChat Username"
                  }
                  onChange={(e) =>
                    setSocialLinks({
                      ...socialLinks,
                      snapchat: e.target.value,
                    })
                  }
                />
                <p className="white character-counter-comment">
                  {socialLinks.snapchat.split("").length}/{maxLengthSnapchat}{" "}
                  characters
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-social"></div>
        {User.username !== "" ||
        User.firstname !== "" ||
        User.lastname !== "" ||
        User.jobtitle !== "" ||
        User.location.city !== "" ||
        User.location.state !== "" ||
        User.location.country !== "US" ||
        summary !== "" ||
        newBlocks ||
        experienceArray.length > 0 ||
        educationArray.length > 0 ||
        skillsArray.length > 0 ||
        socialLinks.instagram !== "" ||
        socialLinks.tiktok !== "" ||
        socialLinks.discord !== "" ||
        socialLinks.twitter !== "" ||
        socialLinks.youtube !== "" ||
        socialLinks.facebook !== "" ||
        socialLinks.snapchat !== "" ||
        imageFile.one !== "" ||
        imageFile.two !== "" ? (
          <div className="submit-changes">
            <button
              className={`submit-changes-button ${
                user && user.role === "innovator"
                  ? "background-green"
                  : user && user.role === "mentor"
                  ? "background-red"
                  : user && user.role === "employer"
                  ? "background-blue"
                  : ""
              }`}
              onSubmit={() => {
                handleSave();
                setFile({ one: "", two: "" });
                setDataFile({ one: "", two: "" });
                setUser({
                  username: "",
                  employername: "",
                  firstname: "",
                  lastname: "",
                  jobtitle: "",
                  location: {
                    city: "",
                    state: "",
                    country: "US",
                  },
                });
                setSocialLinks({
                  instagram: "",
                  tiktok: "",
                  discord: "",
                  twitter: "",
                  youtube: "",
                  facebook: "",
                  snapchat: "",
                });
                setSummary("");
                setEmployerName("");
                setInstitutionName("");
                setSkillName("");
                setPositionItems([]);
                setEducationItems([]);
                setSkillItems([]);
                setPositionItem({ index: null, text: "" });
                setSkillItem({ index: null, text: "" });
                setEducationItem({ index: null, text: "" });
                setCurrent(false);
                setCurrentInstitution(false);
                setCurrentSkill(false);
                setExperienceArray([]);
                setEducationArray([]);
                setSkillsArray([]);
                setNewBlocks(false);
                logout();
              }}
            >
              Update Profile
            </button>
          </div>
        ) : null}
      </form>
    </Fragment>
  );
};

EditProfile.propTypes = {
  getProfileById: PropTypes.func.isRequired,
  updateProfile: PropTypes.func.isRequired,
  getActiveUsers: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  message: state.message,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProfileById,
  getActiveUsers,
  updateProfile,
  logout,
})(EditProfile);
